import React, { useEffect, useState } from "react";
import { BsX } from "react-icons/bs";
import { IoIosCloseCircleOutline } from "react-icons/io";
import ReactAudioPlayer from "react-audio-player";
import { BiSolidHome } from "react-icons/bi";
import { IoHome } from "react-icons/io5";
import ClipLoader from "react-spinners/ClipLoader";

const Cancelled = () => {
  const [missingParams, setMissingParams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const requiredParams = [
      "ticket_number",
      "ticket_id",
      "event_id",
      "business_id",
      "name_first",
      "name_last",
      "email",
      "item_name",
      "admission",
      "customer_id",
    ];

    const urlParams = new URLSearchParams(window.location.search);

    const missing = requiredParams.filter((param) => {
      const value = urlParams.get(param);
      return value === null || value.trim() === "";
    });
    setMissingParams(missing);

    // Add this logic here
    if (missing.length > 0) {
      setLoading(false);
    }

    if (localStorage.getItem("businessid")) {
      setLoading(false);
    }
  }, []);

  let listItems = "";
  if (missingParams.length > 0) {
    listItems = missingParams.map((param) => (
      <div key={param} className="list-item">
        {param}
      </div>
    ));
  }

  // All parameters are present
  const urlParams = new URLSearchParams(window.location.search);
  const ticketId = urlParams.get("ticket_id");
  const eventId = urlParams.get("event_id");
  const businessId = urlParams.get("business_id");
  const campaignId = urlParams.get("campaign_id");
  const ticketNumber = urlParams.get("ticket_number");
  const nameFirst = urlParams.get("name_first");
  const nameLast = urlParams.get("name_last");
  const email = urlParams.get("email");
  const itemName = urlParams.get("item_name");
  const admission = urlParams.get("admission");
  const customerId = urlParams.get("customer_id");
  const group = urlParams.get("group");
  const type_ = urlParams.get("type"); // campaign or ticket_purchase
  const amount = urlParams.get("amount"); // campaign or ticket_purchase

  useEffect(() => {
    if (
      ticketId &&
      eventId &&
      businessId &&
      ticketNumber &&
      nameFirst &&
      nameLast &&
      email &&
      itemName
    ) {
      let apiUrl;

      if (localStorage.getItem("businessid")) {
        apiUrl = `https://karamale.com/apps/kscanner/webservices.php?query=CAMPAIGN-PAYMENT-CANCELLATION&event_id=${eventId}&business_id=${businessId}&campaign_id=${campaignId}&amount=${amount}`;
      } else {
        apiUrl = `https://karamale.com/apps/kscanner/webservices.php?query=CANCELLATION&ticket_id=${ticketId}&event_id=${eventId}&business_id=${businessId}&ticket_number=${ticketNumber}&name_first=${nameFirst}&name_last=${nameLast}&email=${email}&item_name=${itemName}&admission=${admission}&customer_id=${customerId}&group=${group}&amount=${amount}`;
      }

      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          if (data.success) {
            console.log("Ticket cancellation successful:", data);
          } else {
            console.error("Cancellation failed:", data);
          }
        })
        .catch((error) => {
          console.error("Error processing ticket cancellation:", error);
        });
    }
  }, []);

  return (
    <div className="row background-img">
      <div className="w-100 pl-5 pr-5 shield">
        <div className="success-response">
          <div className="row h-100 justify-content-center">
            <div className="align-self-center text-center">
              <div class="message-box">
                {loading && (
                  <div>
                    <ClipLoader />
                    <br />
                    Processing your cancellation...
                  </div>
                )}

                {!loading && (
                  <>
                    {listItems.length > 0 ? (
                      <>
                        <h2>Oops</h2>
                        <p>Missing some important info:</p>
                        {listItems}
                      </>
                    ) : (
                      <>
                        {/* <div style={{ display: "none" }}>
                          <ReactAudioPlayer
                            src="https://karamale.com/apps/kscanner/fail.mp3"
                            autoPlay={true}
                            controls
                          />
                        </div> */}
                        <IoIosCloseCircleOutline size={40} color={"red"} />
                        <h1 style={{ color: "#000", marginTop: 15 }}>
                          Payment Cancelled
                        </h1>
                        <p>
                          Your payment has been successfully cancelled.
                          <br />
                          You haven't been charged
                        </p>
                        <a
                          href={
                            localStorage.getItem("businessid")
                              ? "/dashboard"
                              : "/customerdashboard"
                          }
                          className="new-account-btn text-white"
                        >
                          <IoHome size={20} />
                          &nbsp;&nbsp;Return Home
                        </a>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cancelled;
